import ErrorBoundary, { reportClientError } from "./app/ErrorBoundary";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { PrivacyProvider } from "./components/Privacy";
import { ensureRandomUUID } from "./lib/random-id";
import { registerServiceWorker } from "./app/service-worker";
import { applyDocumentBranding, brandingEnvironment } from "./lib/branding";
import "./styles.css";
ensureRandomUUID();
applyDocumentBranding(brandingEnvironment());
registerServiceWorker();
window.addEventListener("error", e => reportClientError("client_error", e.error));
window.addEventListener("unhandledrejection", e => reportClientError("client_rejection", e.reason));
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary><PrivacyProvider><App /></PrivacyProvider></ErrorBoundary>
  </React.StrictMode>,
);
